import ApiEndpointConstants from "../constants/ApiEndpointConstants";
import api from "./API";

export const deleteComment = (id) => {
  return api.post(`${ApiEndpointConstants.DELETE_COMMENT}`, { id });
};
